import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {sparePartTab} from '../../actions/index';
import SparePartList from './SparePartList';
import SparePartStockIn from './SparePartStockIn';
import SparePartStockOut from './SparePartStockOut';
import SummaryStockOut from './SummaryStockOut';
import HistoryStockOut from './HistoryStockOut';
import SparePartsCost from './SparePartsCost';
import RetailerList from './RetailerList';
import {CarSellUtil, CarsUtil} from "../../utils/carSellUtil";
import {checkGroupPermission, getGroupPermission} from "../../services/grouppermission";
import HistorySparePart from './HistorySparePart'


class SparePart extends Component{
  constructor(props) {
    super(props)
    this.state = {
      menuID: [201, 202, 203, 204, 205, 206, 207, 208],
      grouppermissions: [],
      user: {},
      activeTab: '',
      reloadSparePart: false,
      reloadSummaryStockOut: false,
      reloadSparePartsCost: false
    }

    this.loadGroupPermission = this.loadGroupPermission.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.toggleTabReload = this.toggleTabReload.bind(this);
    this.reloadSparePartFinish = this.reloadSparePartFinish.bind(this);
    this.reloadSummary = this.reloadSummary.bind(this);
    this.reloadSummaryStockOutFinish = this.reloadSummaryStockOutFinish.bind(this);
    this.reloadSparePartsCostFinish = this.reloadSparePartsCostFinish.bind(this);
    this.onReloadSparePart = this.onReloadSparePart.bind(this);
  }

  componentWillMount () {
    this.setState({
      user: JSON.parse(this.props.user)
    })
  }

  componentDidMount() {
    CarsUtil.removeCarSelect();
    CarSellUtil.removeCarSellSelect();
    // console.log('activeTab='+this.props.activeTab)
    this.loadGroupPermission();
    this.setState({
      activeTab: this.props.activeTab
    });
  }

  loadGroupPermission() {
    let type = this.props.type
    let menuID = this.state.menuID
    getGroupPermission(type, menuID).then(res => {
      if(res.data.result === 'success') {
        this.setState({
          grouppermissions: res.data.grouppermissions
        })
      }
    })
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      },()=>{
        this.props.onSparePartTab(tab)
      });
    }
  }

  toggleTabReload(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        reloadSparePart: true
      },()=>{
        this.props.onSparePartTab(tab)
      });
    }
  }

  reloadSummary() {
    this.setState({
      reloadSummaryStockOut: true
    })
  }

  reloadSparePartFinish() {
    this.setState({
      reloadSparePart: false
    })
  }

  onReloadSparePart() {
    this.setState({
      reloadSparePart: true
    })
  }

  //
  reloadSummaryStockOutFinish() {
    this.setState({
      reloadSummaryStockOut: false
    })
  }

  reloadSparePartsCostFinish() {
    this.setState({
      reloadSparePartsCost: false
    })
  }

  render() {
    return (
      <div className="col-md-12 mb-4">
        <Nav tabs>

          {
            checkGroupPermission(201, this.state.grouppermissions).viewed ? (
                <NavItem>
                  <NavLink
                      className={classnames({ active: this.state.activeTab === '1' })}
                      onClick={() => { this.toggleTab('1'); }}
                  >
                    <i className="icon-list"/> รายการอะไหล่
                  </NavLink>
                </NavItem>
            ) : null
          }

          {
            checkGroupPermission(208, this.state.grouppermissions).viewed ? (
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '8' })}
                  onClick={() => { this.toggleTab('8'); }}
                >
                  <i className="icon-book-open"/> รายการต้นทุนอะไหล่
                </NavLink>
              </NavItem>
            ) : null
          }

          {
            checkGroupPermission(202, this.state.grouppermissions).viewed ? (
                <NavItem>
                  <NavLink
                      className={classnames({ active: this.state.activeTab === '2' })}
                      onClick={() => { this.toggleTab('2'); }}
                  >
                    <i className="icon-plus"/> เพิ่มอะไหล่เข้าสต๊อก
                  </NavLink>
                </NavItem>
            ) : null
          }

          {
            checkGroupPermission(203, this.state.grouppermissions).viewed ? (
                <NavItem>
                  <NavLink
                      className={classnames({ active: this.state.activeTab === '3' })}
                      onClick={() => { this.toggleTab('3'); }}
                  >
                    <i className="icon-minus"/> เบิกอะไหล่
                  </NavLink>
                </NavItem>
            ) : null
          }

          {
            checkGroupPermission(207, this.state.grouppermissions).viewed ? (
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '7' })}
                  onClick={() => { this.toggleTab('7'); }}
                >
                  <i className="icon-book-open"/> รายการซื้อเข้า-เบิก
                </NavLink>
              </NavItem>
            ) : null
          }

          {
            checkGroupPermission(204, this.state.grouppermissions).viewed ? (
                <NavItem>
                  <NavLink
                      className={classnames({ active: this.state.activeTab === '6' })}
                      onClick={() => { this.toggleTab('6'); }}
                  >
                    <i className="icon-book-open"/> การเบิกอะไหล่(ลบ)
                  </NavLink>
                </NavItem>
            ) : null
          }

          {
            checkGroupPermission(205, this.state.grouppermissions).viewed ? (
                <NavItem>
                  <NavLink
                      className={classnames({ active: this.state.activeTab === '4' })}
                      onClick={() => { this.toggleTab('4'); }}
                  >
                    <i className="icon-book-open"/> สรุปการเบิกอะไหล่
                  </NavLink>
                </NavItem>
            ) : null
          }



          {
            checkGroupPermission(206, this.state.grouppermissions).viewed ? (
                <NavItem>
                  <NavLink
                      className={classnames({ active: this.state.activeTab === '5' })}
                      onClick={() => { this.toggleTab('5'); }}
                  >
                    <i className="icon-home"/> ร้านค้า
                  </NavLink>
                </NavItem>
            ) : null
          }


        </Nav>

        <TabContent activeTab={this.state.activeTab}>

          <TabPane tabId="1">
            <SparePartList
              user={this.state.user}
              grouppermissions={this.state.grouppermissions}
              reloadSparePart={this.state.reloadSparePart}
              onReloadSparePartFinish={this.reloadSparePartFinish}
            />

            <HistoryStockOut
              user={this.state.user}
              viewType="range"
              reloadSummaryStockOut={this.state.reloadSummaryStockOut}
              onReloadSummaryStockOutFinish={this.reloadSummaryStockOutFinish}
            />
          </TabPane>

          <TabPane tabId="8">
            <SparePartsCost
              user={this.state.user}
              menuID={208}
              grouppermissions={this.state.grouppermissions}
              viewType="range"
              reloadSparePartsCost={this.state.reloadSparePartsCost}
              onReloadSparePartsCostFinish={this.reloadSparePartsCostFinish}
            />
          </TabPane>

          <TabPane tabId="2">
            <SparePartStockIn  user={this.state.user} onToggleTab={this.toggleTabReload} />
          </TabPane>

          <TabPane tabId="3">
            <SparePartStockOut
              user={this.state.user}
              onToggleTab={this.toggleTabReload}
              onReloadSummary={this.reloadSummary}
            />
          </TabPane>

          <TabPane tabId="7">
            <HistorySparePart
              user={this.state.user}
            />
          </TabPane>

          <TabPane tabId="6">
            <HistoryStockOut
              user={this.state.user}
              viewType="range"
              reloadSummaryStockOut={this.state.reloadSummaryStockOut}
              onReloadSummaryStockOutFinish={this.reloadSummaryStockOutFinish}
            />
          </TabPane>

          <TabPane tabId="4">
            <SummaryStockOut
              user={this.state.user}
              viewType="range"
              reloadSummaryStockOut={this.state.reloadSummaryStockOut}
              onReloadSummaryStockOutFinish={this.reloadSummaryStockOutFinish}
            />
          </TabPane>

          <TabPane tabId="5">
            <RetailerList
              grouppermissions={this.state.grouppermissions}
              onReloadSparePart={this.onReloadSparePart}
            />
          </TabPane>

        </TabContent>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  type: state.auth.type,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
  activeTab: state.sparepart.activeTab
})

const mapDispatchToProps = (dispatch) => ({
  onSparePartTab(activeTab) {
    dispatch(sparePartTab(activeTab))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(SparePart);
